import { Box, Checkbox, FormControl, Tooltip } from '@chakra-ui/react'
import { Insurer } from 'BrokerTsLib/src/enums'
import { useContext, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { Loading } from '../../../components/Loading'
import { useApp } from '../../../hooks/useApp'
import { useGetInsurersSpecificParams } from '../../../hooks/useInsuranceParams'
import { LabelHintIcon } from '../../../icons/LabelHintIcon'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { BaScoringCheckbox } from '../BAScoringCheckbox'
import { IndividualCompany } from '../IndividualCompany'
import {
  IndividualDiscountsGroup,
  IndividualDiscountsWrapper,
  LocalInputGroup,
} from '../IndividualDiscountsWrapper'

export const IndividualDiscounts = () => {
  const { environment } = useApp()

  const { insuranceParamsId: paramsId, insuranceParams } = useContext(
    insuranceParamsContext,
  )!
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  const { setValue, getValues } = useFormContext()

  const { refetch, data, isLoading, isFetching } = useGetInsurersSpecificParams(
    paramsId!,
    null,
    {
      enabled: false,
      onSuccess: ({ data }) => {
        setValue('individualDiscounts', data)
      },
    },
  )

  const uniqaIndex = data?.data?.findIndex((x) => x.insurer == Insurer.Uniqa)
  const csobIndex = data?.data?.findIndex((x) => x.insurer == Insurer.Csob)
  const pillowIndex = data?.data?.findIndex((x) => x.insurer == Insurer.Pillow)

  useEffect(() => {
    if (!paramsId) return

    refetch()
  }, [paramsId])

  const loading = isLoading || isFetching
  const youngDriverDesc =
    'Pojišťovna poskytuje slevu na havarijní pojištění, pokud klient ví, že jeho vozidlo nebude řídit osoba mladší 25 let. Pokud by však následně v době vzniku škodní události řídila pojištěné vozidlo osoba mladší 25 let, která není držitelem vozidla, pak bude sjednaná spoluúčast havarijního pojištění navýšena o spoluúčast mladého řidiče ve výši 10 000 Kč.'

  return (
    <IndividualDiscountsWrapper>
      {loading && <Loading large={true} />}

      {!loading && (data?.data ?? []).length > 0 && (
        <>
          {(csobIndex ?? -1) >= 0 && (
            <IndividualDiscountsGroup>
              <IndividualCompany id={Insurer.Csob} name="ČSOB Pojišťovna">
                <FormControl>
                  <BaScoringCheckbox
                    isContracted={isContracted}
                    name={`individualDiscounts.${csobIndex}.baScoring`}
                  />
                </FormControl>

              </IndividualCompany>
            </IndividualDiscountsGroup>
          )}

          <IndividualDiscountsGroup>
            <IndividualCompany id={Insurer.Uniqa} name="UNIQA">
              <FormControl>
                <Checkbox
                  defaultChecked={getValues(
                    `individualDiscounts.${uniqaIndex}.youngDriverComplicity`,
                  )}
                  value="1"
                  isDisabled={isContracted}
                  onChange={(e) =>
                    setValue(
                      `individualDiscounts.${uniqaIndex}.youngDriverComplicity`,
                      e.target.checked,
                    )
                  }
                >
                  Spoluúčast mladého řidiče
                  <Tooltip hasArrow label={youngDriverDesc} placement="auto">
                    <Box
                      sx={{ lineHeight: 0, display: 'inline', marginLeft: 2 }}
                    >
                      <LabelHintIcon width={4} height={4} />
                    </Box>
                  </Tooltip>
                </Checkbox>
              </FormControl>

              <LocalInputGroup
                id="contract-other-uniqa"
                name="contract-other-uniqa"
                label="Pojistná smlouva u Uniqa"
                tooltip="V případě, že má klient sjednanou jinou pojistnou smlouvu u této pojišťovny, může dát pojišťovna dodatečnou slevu na pojistném."
                optional
                isDisabled={isContracted}
                placeholder="Číslo pojistné smlouvy"
                defaultValue={
                  getValues(
                    `individualDiscounts.${uniqaIndex}.contractNumber`,
                  ) ?? ''
                }
                onChange={(e: any) =>
                  setValue(
                    `individualDiscounts.${uniqaIndex}.contractNumber`,
                    e.target.value,
                  )
                }
              />
            </IndividualCompany>
          </IndividualDiscountsGroup>

          <IndividualDiscountsGroup>
            <IndividualCompany id={Insurer.Pillow} name="Pillow">
              <FormControl>
                <Checkbox
                  defaultChecked={getValues(
                    `individualDiscounts.${pillowIndex}.vehicleGaraged`,
                  )}
                  value="1"
                  isDisabled={isContracted}
                  onChange={(e) =>
                    setValue(
                      `individualDiscounts.${pillowIndex}.vehicleGaraged`,
                      e.target.checked,
                    )
                  }
                >
                  Parkuje v garáži
                </Checkbox>
              </FormControl>
            </IndividualCompany>
          </IndividualDiscountsGroup>
        </>
      )}
    </IndividualDiscountsWrapper>
  )
}
